export default __webpack_public_path__ + "static/media/good1.f83deaab.svg";